<template>
    <div class="content-inner">
        <x-panel margin>
            <div slot="title">API Keys</div>
            <div slot="extra" :class="`d-flex justify-content-end`">
                <el-input
                    v-model="listFilters.search"
                    placeholder="Search... "
                    clearable
                    class="filter-item mr-2"
                    @keyup.enter.native="handleFilter(true)"
                    @clear="handleFilter(true)"
                />
                <el-button v-waves type="primary" icon="el-icon-search" @click="handleFilter(true)">Search</el-button>
                <el-button type="success" icon="el-icon-plus" @click="handleCreate">Add</el-button>
            </div>
        </x-panel>
        <el-table
            :data="collection.data"
            style="width: 100%"
            v-loading="loading"
            fit
            ref="filterTable"
            row-key="id"
            border
            default-expand-all
        >
            <el-table-column prop="name" label="Name" width="250"></el-table-column>
            <el-table-column label="API Key" width="250">
                <template slot-scope="scope">
                    <el-input :value="scope.row.api_key" show-password></el-input>
                </template>
            </el-table-column>
            <el-table-column
                label="Team"
                min-width="200"
                v-if="_.get(Ambition, 'Globals.tenant.teams_enabled') && !_.get(Ambition, 'Globals.tenant.currentTeamId')"
            >
                <template slot-scope="scope">
                    <el-tag v-if="_.has(scope.row, 'team.name')" size="small" type="info">
                        {{ _.get(scope.row, "team.name") }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column
                label="Referrer"
                min-width="200"
                header-align="center"
                align="center"
            >
                <template slot-scope="scope">
                    {{ _.get(scope.row, "referrer_user.full_name") }}
                    <br  v-if="_.has(scope.row, 'referrer_user.referrer.name')" />
                    <el-tag v-if="_.has(scope.row, 'referrer_user.referrer.name')" size="small" type="info">
                        {{ _.get(scope.row, "referrer_user.referrer.name") }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="expiration" align="center" width="150" label="Exp. Date"></el-table-column>
            <el-table-column
                prop="description"
                min-width="350"
                header-align="center"
                label="Description"
                style="word-break: normal"
            ></el-table-column>
            <el-table-column prop="whitelist" header-align="center" label="Domains" min-width="350" style="word-break: normal">
                <template slot-scope="scope">
                    {{ _.get(scope.row, "whitelist") ? Object.values(scope.row.whitelist).join(", ") : "" }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="Status" min-width="150">
                <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.deleted_at ? 'danger' : 'success'">
                        {{ scope.row.deleted_at ? "Deactivated" : "Active" }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column label="Action" width="110" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-dropdown class="w-100">
                        <el-button style="color: green" size="small" @click="handleActionButtonClick">
                            Action
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="handleEdit(scope.row)">
                                <span>Edit</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handleDeactivate(scope.row)" v-if="!scope.row.deleted_at">
                                <span>Deactivate</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handleActivate(scope.row)" v-if="scope.row.deleted_at">
                                <span>Activate</span>
                            </el-dropdown-item>
                            <el-dropdown-item @click.native="handlePermenantDelete(scope.row)" v-if="scope.row.deleted_at">
                                <span>Remove</span>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="collection.total > 0"
            :total="collection.total"
            :page.sync="collection.current_page"
            :limit.sync="collection.per_page"
            @pagination="getCollection"
        />

        {{ /* Add IP */ }}
        <el-dialog :class="`merge-dialog`" title="API" :visible.sync="modal.show" :modal="false">
            <div slot="title">
                {{ modal.action == "create" ? "Generate API Key" : "Edit Key Details" }}
            </div>
            <div class="row group-class">
                <div class="col-12 col-lg-6">
                    <label for="name">Name</label>
                    <el-input class="mb-3" name="name" v-model="entry.name"></el-input>
                </div>

                <div class="col-12 col-lg-6">
                    <label for="expiration">
                        Expiration
                        <small>(optional)</small>
                    </label>
                    <el-date-picker
                        name="expiration"
                        v-model="entry.expiration"
                        type="date"
                        class="w-100"
                        placeholder="Pick an expiration"
                    ></el-date-picker>
                </div>

                <div
                    class="col-12"
                    v-if="_.get(Ambition, 'Globals.tenant.teams_enabled') && !_.get(Ambition, 'Globals.tenant.currentTeamId')"
                >
                    <label for="description">Restrict to team</label>
                    <el-select placeholder="Select Team" style="width: 100%" v-model="entry.team_id" class="mb-3">
                        <el-option key="any" label="Any" value="any"></el-option>
                        <el-option v-for="team in teams" :key="team.id" :label="team.name" :value="team.id"></el-option>
                    </el-select>
                </div>

                <div
                    class="col-12"
                >
                    <label for="description">Restrict to Referrer?</label>
                    <el-cascader
                        v-model="entry.referrer_id"
                        :options="mappedOptions"
                        :show-all-levels="true"
                        :props="{ multiple: false, checkStrictly: false, emitPath: false}"
                        popper-class="report-columns-cascader"
                        placeholder="Select referrer user to assign"
                        class="w-100 mb-3"
                        clearable
                    ></el-cascader>
                </div>

                <div class="col-12">
                    <label for="description">Description</label>
                    <el-input type="textarea" class="mb-3" name="description" v-model="entry.description"></el-input>
                </div>

                <div class="col-12">
                    <label for="whitelist">
                        Whitelisted Domains
                        <small>(optional)</small>
                    </label>
                    <el-tag
                        :key="domain"
                        v-for="domain in entry.whitelist"
                        closable
                        class="w-100 domain"
                        :disable-transitions="false"
                        @close="handleWhitelistClose(domain)"
                    >
                        {{ domain }}
                    </el-tag>
                    <el-input
                        class="input-new-domain w-100"
                        v-if="domainInputVisible"
                        v-model="domainInputValue"
                        ref="saveDomainInput"
                        size="mini"
                        @keyup.enter.native="handleWhitelistInputConfirm"
                        @blur="handleWhitelistInputConfirm"
                    ></el-input>
                    <hr />

                    <el-button class="button-new-domain" size="small" @click="showWhitelistInput">+ Add Domain</el-button>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleReset()">Cancel</el-button>
                <el-button type="success" @click="handleSubmit()">
                    {{ modal.action == "create" ? "Generate" : "Update" }}
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
    import Pagination from '@shared/components/pagination'
    import ipInput from './IpInput'
    export default {
        name: 'ApiKeys',
        components: { Pagination, ipInput },
        props: {
            referrers: Array,
        },
        data() {
            return {
                collection: {},
                search: '',
                loading: true,
                listFilters: {
                    search: '',
                    team_id: _.get(Ambition, 'Globals.tenant.currentTeamId'),
                },
                listLimit: 10,
                actionOptions: [
                    {
                        value: 0,
                        label: 'Deny'
                    }, {
                        value: 1,
                        label: 'Allow'
                    }
                ],
                modal: {
                    show: false,
                    action: ''
                },
                entry: {
                    name: '',
                    expiration: '',
                    description: '',
                    team_id: _.get(Ambition, 'Globals.tenant.currentTeamId'),
                    referrer_id: '',
                    whitelist: []
                },
                domainInputVisible: false,
                domainInputValue: '',
                selected: {},
            }
        },
        computed: {
            ...mapGetters({
                teams: "ambition/getTeams",
            }),
            columnGroups() {
                return [
                    {
                        name: "Referrers",
                        fields: this.referrers.map((referrer) => {
                            let field = {}
                            field = {
                                value: {type: "referrer", id: referrer.id},
                                label: referrer.name,
                            }

                            if (referrer.users.length > 0) {
                                field.children = referrer.users
                                    .map((user) => {
                                        return {
                                            value: user.id,
                                            label: user.full_name,
                                        }
                                    })
                                    .filter((e) => e)
                            }

                            return field
                        }),
                    }
                ]
            },
            mappedOptions() {
                return this.columnGroups.map((columnGroup) => {
                    return {
                        value: columnGroup.name,
                        disabled: _.get(columnGroup, "disabled", false),
                        label: columnGroup.name,
                        children: columnGroup.fields
                            .map((field) => {
                                return {
                                    value: field.value,
                                    disabled: _.get(columnGroup, "disabled", false),
                                    label: field.label,
                                    children: _.get(field, "children", null),
                                }
                            })
                            .filter((e) => e),
                    }
                })
            },
        },
        watch: {
        },
        mounted() {
            if (_.get(Ambition, 'Globals.tenant.teams_enabled') && !_.get(Ambition, 'Globals.tenant.currentTeamId')) {
                this.$store.dispatch('ambition/setTeams');
            }
            this.handleFilter();
        },
        updated() {
        },
        activated() {
        },
        methods: {
            setData(res, model) {
                this.$set(this.$data, model, res.data.collection)
                this.loading = false;
                this.$bar.finish()
            },
            handleWhitelistClose(domain) {
                this.entry.whitelist.splice(this.entry.whitelist.indexOf(domain), 1);
            },
            showWhitelistInput() {
                this.domainInputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveDomainInput.$refs.input.focus();
                });
            },
            handleWhitelistInputConfirm() {
                let inputValue = this.domainInputValue;
                if (inputValue) {
                    this.entry.whitelist.push(inputValue);
                }
                this.domainInputVisible = false;
                this.domainInputValue = '';
            },
            clearFilter() {
                this.$refs.filterTable.clearFilter();
            },
            handleFilter(loading = false) {
                this.loading = loading;
                let collection = this.collection;
                let event = {
                    page: 1,
                    limit: _.get(collection, 'per_page', 10)
                }
                this.getCollection(event);
            },
            handleCreate() {
                this.modal.show = true;
                this.modal.action = 'create';
            },
            handleSubmit() {
                if (this.modal.action == 'create') {
                    this.create();
                } else if (this.modal.action == 'edit') {
                    this.edit();
                }
            },
            create() {
                this.$tenant.post(`/api/settings/api-keys/create`,
                    this.entry)
                    .then((res) => {
                        this.handleFilter()
                        this.handleReset();
                    }).catch(err => {
                        err.output()
                    })
            },
            handleReset() {
                let entry = {
                    name: '',
                    team_id: parseInt(_.get(Ambition, 'Globals.tenant.currentTeamId')),
                    referrer_id: '',
                    expiration: '',
                    description: '',
                    whitelist: []
                }
                this.modal.show = false;
                this.entry = entry;
            },
            handleEdit(row, id) {
                let entry = {
                    id: row.id,
                    name: row.name,
                    referrer_id:  parseInt(_.get(row, 'referrer_id')),
                    team_id: parseInt(_.get(row, 'team_id')),
                    whitelist: row.whitelist,
                    expiration: row.expiration,
                    description: row.description
                }
                this.entry = entry;
                this.modal.action = 'edit';
                this.modal.show = true;
            },
            edit() {
                this.$tenant.post(`/api/settings/api-keys/${this.entry.id}/update`,
                    this.entry)
                    .then((res) => {
                        this.handleFilter()
                        this.handleReset();
                    }).catch(err => {
                        err.output()
                    })
            },
            handleActivate(row) {
                this.$tenant.get(`/api/settings/api-keys/${row.id}/activate`)
                    .then((res) => {
                        this.handleFilter();
                    }).catch(err => {
                        err.output()
                    })
            },
            handleDeactivate(row) {
                this.selected = row;
                this.delete(row.id);
            },
            delete(id) {
                this.$tenant.get(`/api/settings/api-keys/${id}/delete`)
                    .then((res) => {
                        this.handleFilter();
                        this.selected = {};
                    }).catch(err => {
                        err.output()
                    })
            },
            handlePermenantDelete(row) {
                this.$confirm('Are you sure to permanently delete this API Key?')
                    .then(() => {
                        this.$tenant.get(`/api/settings/api-keys/${row.id}/permenant-delete`)
                            .then((res) => {
                                this.handleFilter();
                                this.selected = {};
                            })
                    })
                    .catch(err => {
                        err.output()
                    })
            },
            getCollection(event) {
                this.$bar.start()
                this.$tenant.get(`/api/settings/api-keys?page=${event.page}&per_page=${event.limit}&${this.$serialize(this.listFilters)}`)
                    .then(res => {
                        this.$set(this.$data, 'collection', res.data.collection)
                        this.loading = false;
                        this.$bar.finish()
                    }).catch(err => {
                        err.output()
                    })
            },
            handleActionButtonClick(e) {
                e.stopPropagation()
            }
        }
    }
</script>

<style lang="scss">
    // @import '@assets/sass/backend/_core-variables.scss';
    .el-tag {
        &.domain {
            margin-top: 10px;
            display: flex !important;
            justify-content: space-between;
            align-items: center;
        }
    }
    .button-new-domain {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-domain {
        margin-top: 10px;
        vertical-align: bottom;
    }
</style>
